import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Select,
  Text,
  TextInput,
  Table,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState } from "@mantine/hooks";
import {
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  repositoryDelivery,
  styleTableMantine,
} from "../../_base/_const/_constVar";
import { getBranchSelectMdm, getTblDmEmployeeSelect } from "../../service/getSelectApi";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { MessageResponse } from "../../model/MessageResponse";
import { _localization } from "../../config/location";
import { green, red, sky_blue } from "../../const/variables";

const ServiceRepairTestingTechniqueList = () => {
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(window.innerHeight - 280);
  const [dataTblBranch, setDataTblBranch] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  // Khoá là detailId — MỖI SERIAL MỘT DÒNG. Không dùng assignmentId: một phiếu nhập nhiều
  // serial chỉ có một bản ghi phân công nên các dòng sẽ dùng chung ô nhập của nhau.
  const [modifiedRows, setModifiedRows] = useState<Record<string, { status?: string, note?: string, detailId?: number, assignmentId?: number }>>({});

  const handleConfirmSave = () => {
    const keys = Object.keys(modifiedRows);
    if (keys.length === 0) return;

    const changedItems: any[] = [];
    for (const key of keys) {
      const detailId = Number(key);
      const rowData = modifiedRows[key];
      const originalRow = data.find(x => x.detailId === detailId);

      if (!originalRow) continue;

      const newStatus = rowData.status !== undefined ? rowData.status : originalRow.testingStatus;
      const newNote = rowData.note !== undefined ? rowData.note : (originalRow.noteByEmployee || "");

      if (newStatus !== originalRow.testingStatus || newNote !== (originalRow.noteByEmployee || "")) {
        changedItems.push({
          sourceCode: originalRow.sourceCode,
          itemCode: originalRow.itemCode,
          itemName: originalRow.itemName,
          serialCode: originalRow.serialCode,
          oldStatus: dataStatusOption.find(x => x.value === originalRow.testingStatus)?.label || originalRow.testingStatus,
          newStatus: dataStatusOption.find(x => x.value === newStatus)?.label || newStatus,
          oldNote: originalRow.noteByEmployee || "",
          newNote: newNote
        });
      }
    }

    if (changedItems.length === 0) return;

    modals.openConfirmModal({
      title: "Xác nhận lưu thay đổi",
      centered: true,
      size: "xl",
      children: (
        <div style={{ paddingBottom: 24, paddingTop: 5 }}>
          <Text size="lg" fw={600} ta="center" mb={8}>
            Bạn có chắc chắn muốn lưu các thay đổi sau?
          </Text>
          <Box my="md" p="sm" style={{ border: "1px solid #e2e8f0", borderRadius: 8 }}>
            <Table withTableBorder withColumnBorders>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Mã chứng từ</Table.Th>
                  <Table.Th>Sản phẩm</Table.Th>
                  <Table.Th>Serial</Table.Th>
                  <Table.Th>Trạng thái</Table.Th>
                  <Table.Th>Ghi chú</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {changedItems.map((item, idx) => (
                  <Table.Tr key={idx}>
                    <Table.Td>
                      <Text size="sm">{item.sourceCode}</Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm">{item.itemCode}</Text>
                      {item.itemName && <Text size="xs" c="dimmed" truncate="end" maw={200}>{item.itemName}</Text>}
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm">{item.serialCode}</Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm">
                        {item.oldStatus !== item.newStatus ? (
                          <>
                            <Text component="span" c="dimmed" td="line-through">{item.oldStatus}</Text>
                            <Text component="span" mx={5}>{"->"}</Text>
                            <Text component="span" c="blue" fw={500}>{item.newStatus}</Text>
                          </>
                        ) : (
                          <Text component="span">{item.newStatus}</Text>
                        )}
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm">
                        {item.oldNote !== item.newNote ? (
                          <>
                            <Text component="span" c="dimmed" td="line-through">{item.oldNote || "(trống)"}</Text>
                            <Text component="span" mx={5}>{"->"}</Text>
                            <Text component="span" c="blue" fw={500}>{item.newNote || "(trống)"}</Text>
                          </>
                        ) : (
                          <Text component="span">{item.newNote}</Text>
                        )}
                      </Text>
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </Box>
        </div>
      ),
      labels: { confirm: "Đồng ý", cancel: "Hủy" },
      onConfirm: () => handleBatchSave(),
    });
  };

  const handleBatchSave = async () => {
    const keys = Object.keys(modifiedRows);
    if (keys.length === 0) return;

    // Gửi kèm detailId để BE chỉ cập nhật đúng dòng serial (tbl_testing_technique_detail.id);
    // assignmentId dùng chung cho mọi serial của phiếu nên không đủ để xác định dòng.
    const items: { assignmentId: number; detailId: number; testingStatus: string; note: string }[] = [];

    for (const key of keys) {
      const detailId = Number(key);
      const rowData = modifiedRows[key];
      const originalRow = data.find(x => x.detailId === detailId);

      if (!originalRow) continue;

      const newStatus = rowData.status !== undefined ? rowData.status : originalRow.testingStatus;
      const newNote = rowData.note !== undefined ? rowData.note : (originalRow.noteByEmployee || "");

      // Check if actually changed
      if (newStatus !== originalRow.testingStatus || newNote !== (originalRow.noteByEmployee || "")) {
        items.push({
          assignmentId: originalRow.assignmentId,
          detailId: originalRow.detailId,
          testingStatus: newStatus,
          note: newNote,
        });
      }
    }

    if (items.length === 0) {
      setModifiedRows({});
      return;
    }

    try {
      const req = await repositoryDelivery.post<MessageResponse<any>>(
        "/api/v1/TblTestingTechniqueHeader/update-status-service-repair",
        { items }
      );
      
      if (req) {
        if (req.success) {
          NotificationExtension.Success(`Đã lưu thay đổi thành công!`);
          fetchData();
        } else {
          NotificationExtension.Fails(req.message || "Cập nhật thất bại!");
        }
      }
    } catch (error: any) {
      // Unlikely to hit due to HttpHelper swallowing errors, but safe to keep.
      console.error(error);
    }

    setModifiedRows({});
  };

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 280);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });

  const [search, setSearch] = useState<any>({
    keySearch: "",
    status: "",
    branch: "",
    creatorName: "",
    employeeName: "",
    serialCode: "",
    itemCode: "",
  });

  const dataStatusOption = [
    { value: "TAO_MOI", label: "Tạo mới", color: sky_blue.base },
    { value: "PHAN_CONG", label: "Phân công", color: "#FD8622" },
    { value: "DANG_KIEM_TRA", label: "Đang kiểm tra", color: "#d9d02f" },
    { value: "TEST_MOT_PHAN", label: "Test một phần", color: "#ffcc00" },
    { value: "TEST_LOI", label: "Test lỗi", color: "red" },
    { value: "TEST_OK", label: "Test ok", color: "#17a2b8" },
    { value: "HUY_PHAN_CONG", label: "Hủy phân công", color: "red" },
    { value: "HUY", label: "Hủy", color: "gray" },
  ];

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    let url = `?Skip=${pagination.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch.trim()}`;
    }
    if (search.status) {
      url += `&Status=${search.status}`;
    }
    if (search.branch) {
      url += `&BranchId=${search.branch}`;
    }
    if (search.creatorName) {
      url += `&CreatorName=${search.creatorName.trim()}`;
    }
    if (search.employeeName) {
      url += `&EmployeeName=${search.employeeName.trim()}`;
    }
    if (search.serialCode) {
      url += `&SerialCode=${search.serialCode.trim()}`;
    }
    if (search.itemCode) {
      url += `&ItemCode=${search.itemCode.trim()}`;
    }

    try {
      const response = await repositoryDelivery.get(
        `/api/v1/TblTestingTechniqueHeader/get-defective-list${url}`
      );
      if (response && response.data) {
        setData(response.data);
        setRowCount(response.totalCount ?? 0);
      }
    } catch (error) {
      NotificationExtension.Fails("Lỗi khi tải dữ liệu");
    }

    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    const fetchSelects = async () => {
      const branchData = await getBranchSelectMdm();
      if (branchData) {
        setDataTblBranch(
          branchData
            // Dịch vụ sửa chữa chỉ làm việc với chi nhánh pháp nhân DVT (attr6 = CompanyCode)
            .filter((item: any) => item.value != null && item.text != null && item.value != "-1" && item.attr6 === "DVT")
            .map((item) => ({
              value: item.value.toString(),
              label: item.att2 ? `${item.att2} - ${item.text}` : item.text,
            }))
        );
      }
      
      const empData = await getTblDmEmployeeSelect();
      if (empData) {
        setDataEmployee(
          empData
            .filter((item) => item.value != null && item.text != null)
            .map((item) => ({
              value: item.value.toString(),
              label: item.att1 ? `${item.att1} - ${item.text}` : item.text,
            }))
        );
      }
    };
    fetchSelects();
  }, []);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "headerCode",
        header: "Mã phiếu",
        size: 130,
      },
      {
        accessorKey: "sourceCode",
        header: "Mã chứng từ gốc",
        size: 130,
      },
      {
        accessorKey: "sourceStatus",
        header: "Trạng thái phiếu",
        size: 130,
        Cell: ({ renderedCellValue }) => {
          const status = renderedCellValue as string;
          const option = dataStatusOption.find((opt) => opt.value === status);
          return option ? (
            <Badge color={option.color} variant="light">
              {option.label}
            </Badge>
          ) : (
            <Text size="sm">{status}</Text>
          );
        },
      },
      {
        accessorKey: "invOrgCode",
        header: "Chi nhánh",
        size: 130,
      },
      {
        accessorKey: "sourceType",
        header: "Loại phiếu",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          const val = renderedCellValue as string;
          const label =
            val === "NHAP_KHO_BH_NCC"
              ? "Nhập kho BH NCC"
              : val === "NHAP_KHO_BH"
                ? "Nhập kho bảo hành"
                : val;
          const color =
            val === "NHAP_KHO_BH_NCC" ? "indigo" : "teal";
          return (
            <Badge color={color} variant="light" radius="sm">
              {label}
            </Badge>
          );
        },
      },
      {
        accessorKey: "createDate",
        header: "Ngày lập",
        size: 130,
        Cell: ({ renderedCellValue }) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue as string)}</>
        ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        size: 100,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 200,
      },
      {
        accessorKey: "serialCode",
        header: "Serial",
        size: 100,
      },
      {
        accessorKey: "creatorName",
        header: "Người yêu cầu kiểm tra",
        size: 150,
      },
      {
        accessorKey: "description",
        header: "Ghi chú của người yêu cầu",
        size: 180,
      },
      {
        accessorKey: "employeeName",
        header: "Người được phân công",
        size: 150,
      },
      {
        accessorKey: "lastTesterName",
        header: "Người kiểm tra gần nhất",
        size: 170,
      },
      {
        accessorKey: "testingStatus",
        header: "Trạng thái",
        size: 160,
        Cell: ({ row, renderedCellValue }) => {
          const currentStatus = renderedCellValue as string;
          // Use modified state if it exists, otherwise fallback to original
          const id = row.original.detailId;
          const displayStatus = modifiedRows[id]?.status !== undefined 
            ? modifiedRows[id].status 
            : currentStatus;

          return (
            <Select
              data={dataStatusOption
                .filter(
                  (opt) =>
                    opt.value === "TEST_LOI" ||
                    opt.value === "TEST_OK" ||
                    opt.value === "HUY" ||
                    opt.value === displayStatus
                )
                .map((opt) => ({
                  value: opt.value,
                  label: opt.label,
                }))}
              // Chỉ mở khi serial CHƯA rời giai đoạn của phiếu KTKT này. BE trả cờ canUpdate
              // (tính đúng 3 chốt của UpdateServiceRepairTestingTechniqueCommand) kèm lý do.
              disabled={row.original.canUpdate === false}
              // hiện lý do khi hover, không dùng Tooltip để không làm cao thêm hàng
              title={row.original.canUpdate === false ? row.original.canUpdateNote ?? "" : undefined}
              value={displayStatus}
              onChange={(value) => {
                if (value) {
                  setModifiedRows(prev => {
                    const next = { ...prev };
                    const id = row.original.detailId;
                    if (!next[id]) next[id] = { detailId: id, assignmentId: row.original.assignmentId };
                    next[id].status = value;
                    
                    const currentNote = next[id].note !== undefined ? next[id].note : (row.original.noteByEmployee || "");
                    if (currentNote === (row.original.noteByEmployee || "") && value === row.original.testingStatus) {
                      delete next[id];
                    }
                    
                    return next;
                  });
                }
              }}
              styles={{
                input: {
                  fontSize: "11.5px",
                  height: "26px",
                  minHeight: "26px",
                  paddingLeft: "6px",
                },
              }}
            />
          );
        },
      },
      {
        accessorKey: "noteByEmployee",
        header: "Ghi chú",
        size: 180,
        Cell: ({ row, renderedCellValue }) => {
          const initialValue = (renderedCellValue as string) || "";
          // Use modified state if it exists, otherwise fallback to original
          const id = row.original.detailId;
          const displayNote = modifiedRows[id]?.note !== undefined 
            ? modifiedRows[id].note 
            : initialValue;

          return (
            <TextInput
              disabled={row.original.canUpdate === false}
              title={row.original.canUpdate === false ? row.original.canUpdateNote ?? "" : undefined}
              defaultValue={displayNote}
              onBlur={(e) => {
                const val = e.currentTarget.value;
                if (val !== displayNote) {
                  setModifiedRows(prev => {
                    const next = { ...prev };
                    const id = row.original.detailId;
                    if (!next[id]) next[id] = { detailId: id, assignmentId: row.original.assignmentId };
                    next[id].note = val;

                    const currentStatus = next[id].status !== undefined ? next[id].status : row.original.testingStatus;
                    if (val === (row.original.noteByEmployee || "") && currentStatus === row.original.testingStatus) {
                      delete next[id];
                    }

                    return next;
                  });
                }
              }}
              styles={{
                input: {
                  fontSize: "11.5px",
                  height: "26px",
                  minHeight: "26px",
                  paddingLeft: "6px",
                },
              }}
            />
          );
        },
      },
    ],
    [modifiedRows]
  );

  const table = useMantineReactTable({
    columns,
    data,
    // Mỗi dòng lưới là một serial ⇒ khoá phải là detailId, assignmentId bị trùng giữa các serial
    getRowId: (row) => row.detailId?.toString(),
    enableColumnFilters: false,
    enablePagination: true,
    enableBottomToolbar: true,
    enableTopToolbar: true,
    renderToolbarInternalActions: ({ table }) => <></>,
    renderTopToolbarCustomActions: () => (
      <div style={{ width: "100%" }}>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <TextInput
              size="sm"
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch size="1rem" />}
              value={search.keySearch}
              onChange={(e) => setSearch({ ...search, keySearch: e.currentTarget.value })}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <Select
              size="sm"
              placeholder="Trạng thái sản phẩm"
              data={[{ value: "", label: "Tất cả" }, ...dataStatusOption.map((x) => ({ value: x.value, label: x.label }))]}
              value={search.status}
              onChange={(value) => setSearch({ ...search, status: value || "" })}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <Select
              size="sm"
              placeholder="Chi nhánh"
              searchable
              clearable
              data={dataTblBranch || []}
              value={search.branch}
              onChange={(value) => setSearch({ ...search, branch: value || "" })}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <Select
              size="sm"
              placeholder="Người yêu cầu"
              searchable
              clearable
              data={dataEmployee}
              value={search.creatorName}
              onChange={(value) => setSearch({ ...search, creatorName: value || "" })}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <Select
              size="sm"
              placeholder="Người kiểm tra"
              searchable
              clearable
              data={dataEmployee}
              value={search.employeeName}
              onChange={(value) => setSearch({ ...search, employeeName: value || "" })}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <TextInput
              size="sm"
              placeholder="Mã serial"
              value={search.serialCode}
              onChange={(e) => setSearch({ ...search, serialCode: e.currentTarget.value })}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <TextInput
              size="sm"
              placeholder="Mã sản phẩm"
              value={search.itemCode}
              onChange={(e) => setSearch({ ...search, itemCode: e.currentTarget.value })}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 4, sm: 3, lg: 1.5 }}>
            <Button
              variant="outline"
              leftSection={<IconSearch size="1rem" />}
              fullWidth
              onClick={() => {
                setPagination({ ...pagination, pageIndex: 0 });
                fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    manualPagination: true,
    rowCount,
    state: {
      isLoading,
      pagination,
      showAlertBanner: false,
      showProgressBars: isRefetching,
    },
    initialState: {
      density: "xs",
      columnPinning: { right: ["testingStatus", "noteByEmployee"] },
    },
    enableColumnPinning: true,
    onPaginationChange: setPagination,
    enableColumnResizing: true,
    enableRowSelection: true,
    enableRowNumbers: true,
    enableStickyHeader: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    positionToolbarAlertBanner: "bottom",
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    mantineTableProps: {
      striped: false,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    mantineTableBodyCellProps: () => ({
      style: styleTableMantine,
    }),
    localization: _localization,
  });

  return (
    <>
      <Flex justify="space-between" align="center" mb="xs" pr="sm">
        <_breadcrumb />
        {Object.keys(modifiedRows).length > 0 && (
          <Button
            color="green"
            size="sm"
            onClick={handleConfirmSave}
          >
            Lưu thay đổi
          </Button>
        )}
      </Flex>
      <Box m="xs">
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ServiceRepairTestingTechniqueList;
